export const mixinRoutesHandler = {
  methods: {
      _mixinGoToRouteName(routeName) {
          if (this.$route.name !== routeName) {
              this.$router.push({
                  name: routeName
              });
          }
      },

      // TODO: Make more clean, some day we will have more than one lvl children.
      _mixinGetRoutePath(routeName) {
          let declaredRoutes = this.$router.options.routes;

          for (let prop in declaredRoutes) {
              let hasBarProperty = Object.prototype.hasOwnProperty.call(declaredRoutes, prop);

              if (hasBarProperty && declaredRoutes[prop].name === routeName) {
                  return declaredRoutes[prop].path;
              } else if (hasBarProperty && declaredRoutes[prop].children && declaredRoutes[prop].children.length > 0) {
                  const children = declaredRoutes[prop].children;

                  for (let cProp in children) {
                      if (children[cProp].name === routeName) {

                          // If empty use parent path
                          if (!children[cProp].path) {
                              return declaredRoutes[prop].path;
                          }

                          return children[cProp].path;
                      }
                  }
              }
          }

          return '#';
      },

      _mixinGetRoutePathWithParams(routeName, params) {
          let declaredRoutes = this.$router.options.routes;

          for (let prop in declaredRoutes) {

              let hasBarProperty = Object.prototype.hasOwnProperty.call(declaredRoutes, prop);
              if (hasBarProperty && declaredRoutes[prop].name === routeName) {

                  for (const [key, value] of Object.entries(params)) {
                      if (declaredRoutes[prop].path.includes(key)) {
                          return declaredRoutes[prop].path.replace(`:${key}`, value)
                      }
                  }

                  return declaredRoutes[prop].path;
              }
          }

          return '#';
      },

      _mixinRoutesHandler_getRoutesAVisibleIn(array) {
          const routes = this.$router.options.routes;

          let filtered = [];
          if (array.includes('footerQuickLinks')) {
              filtered = routes.filter((route) => {
                  return 'visibleIn' in route && route.visibleIn.includes('footerQuickLinks');
              });
          } else if (array.includes('sitemap')) {
              filtered = routes.filter((route) => {
                  return 'visibleIn' in route && route.visibleIn.includes('sitemap');
              });
          } else {
              return [];
          }

          return filtered.length > 0 ? filtered : [];
      },

      _mixinRoutesHandler_getRoutesFiltered(routeNames) {
          let filtered = this.$router.options.routes.filter((route) => {
              return routeNames.includes(route.name);
          });

          // The order is inherited from $router, sort is necessary to preserve the order provided with routeNames array
          if (filtered.length > 0) {
              return filtered.sort(function(a, b) {
                  return routeNames.indexOf( a.name ) - routeNames.indexOf( b.name );
              });
          }

        return [];
      },
  },
};
